import { render } from "./FeatureBlocksSubsection.vue?vue&type=template&id=81539434&ts=true"
import script from "./FeatureBlocksSubsection.vue?vue&type=script&lang=ts"
export * from "./FeatureBlocksSubsection.vue?vue&type=script&lang=ts"

import "./FeatureBlocksSubsection.vue?vue&type=style&index=0&id=81539434&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__